import React from 'react';
import NoOptionsMessage from './NoOptionsMessage';
import CreateNew from './CreateNew';

const NoOptionsWithAddNew = ({
  customNoResult,
  sizeValue,
  className,
  MenuProps
}) => {
  const {
    creatable,
    onCreate,
    focusOnSelect,
    onCreateNew,
    AddButtonProps
  } = MenuProps;
  // AddButtonProps is provided on custom create new wheres onCreate is provided on default create new
  const shouldDisplayCreateNew = creatable && (onCreate || AddButtonProps);
  const header = shouldDisplayCreateNew && (
    <CreateNew
      onChange={onCreateNew}
      onClose={focusOnSelect}
      AddButtonProps={AddButtonProps}
    />
  );
  return (
    <NoOptionsMessage
      className={className}
      header={header}
      customNoResult={customNoResult}
      sizeValue={sizeValue}
    />
  );
};

export default NoOptionsWithAddNew;
